import { render, staticRenderFns } from "./EpisodeComponent.vue?vue&type=template&id=f940f0e0&scoped=true&"
import script from "./EpisodeComponent.vue?vue&type=script&lang=js&"
export * from "./EpisodeComponent.vue?vue&type=script&lang=js&"
import style0 from "./EpisodeComponent.vue?vue&type=style&index=0&id=f940f0e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f940f0e0",
  null
  
)

export default component.exports